// src/components/datePicker/VetCheckDatePicker.js
import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export default function VetCheckDatePicker({ value, isNA, explanation, onChange }) {
  const [selectedDate, setSelectedDate] = useState(value || null);
  const [notApplicable, setNotApplicable] = useState(isNA || false);
  const [naExplanation, setNaExplanation] = useState(explanation || '');

  const today = new Date();
  const twoYearsAgo = new Date();
  twoYearsAgo.setFullYear(today.getFullYear() - 2);

  useEffect(() => {
    onChange({
      vetCheckDate: notApplicable ? null : selectedDate,
      vetCheckNA: notApplicable,
      vetCheckExplanation: notApplicable ? naExplanation : ''
    });
  }, [selectedDate, notApplicable, naExplanation]);

  return (
    <div className="space-y-2">
      <DatePicker
        selected={selectedDate}
        onChange={(date) => setSelectedDate(date)}
        minDate={twoYearsAgo}
        maxDate={today}
        placeholderText="Select a date"
        disabled={notApplicable}
        className="w-full border rounded px-3 py-2"
      />
      <div className="mt-2">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            checked={notApplicable}
            onChange={(e) => setNotApplicable(e.target.checked)}
            className="mr-2"
          />
          Not Applicable
        </label>
      </div>
      {notApplicable && (
        <div className="mt-2">
          <label className="block text-sm font-bold mb-1">Please explain</label>
          <textarea
            value={naExplanation}
            onChange={(e) => setNaExplanation(e.target.value)}
            className="w-full border rounded px-3 py-2"
            placeholder="Provide an explanation..."
          />
        </div>
      )}
    </div>
  );
}